import { P2 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { Image } from 'components/BackgroundReplacer/styles';
import { FlexColumn, FlexContainer } from 'styles/layouts';

export const Wrapper = styled(FlexContainer)`
  gap: 16px;
  flex-direction: column;

  ${QUERIES.largeTabletAndUp} {
    gap: 24px;
    flex-direction: row;
  }
`;

export const SourceTemplateWrapper = styled.div`
  aspect-ratio: 1/1;

  ${QUERIES.largeTabletAndUp} {
    aspect-ratio: auto;
  }
`;

export const ModalWrapper = styled.div`
  padding: 20px;
  height: 100%;
  gap: 16px;
  display: grid;
  grid-template-rows: 24px 1fr 40px;
  position: relative;
  overflow: scroll;
`;

export const ImageWrapper = styled(FlexColumn)<{ hasPrompt: boolean }>`
  flex-grow: 1;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  aspect-ratio: 1/1;
  border-radius: ${themeStyle.radiusLarge};

  ${QUERIES.tabletAndUp} {
    max-height: ${({ hasPrompt }) =>
      hasPrompt ? `calc(100vh - 240px)` : `calc(100vh - 216px)`};
  }
`;

export const ImagePreview = styled(Image)`
  border-radius: ${themeStyle.radiusLarge};
`;

export const PromptWrapper = styled.div`
  padding-bottom: 24px;
  position: absolute;
  width: 100%;
`;

export const Prompt = styled.div`
  background-color: ${themeStyle.varBackgroundBase};
  border-radius: ${themeStyle.radiusMedium};
  padding: 12px;
`;

export const PromptText = styled(P2)`
  word-break: break-all;
`;
